<template>
  <div class="accordion-element g-grey-box">
    <div
      class="accordion-element__header"
      @click.stop="toggleState"
    >
      <div class="accordion-element__header__text">
        <div
          v-if="Data.icon"
          class="accordion-element__icon"
          :class="status"
        >
          <font-awesome-icon :icon="Data.icon" />
        </div>
        <div class="">
          <h3
            v-if="Data.title"
            class="accordion-element__title"
          >
            {{ Data.title }}
          </h3>
          <h4
            v-if="Data.subTitle"
            class="accordion-element__title accordion-element__title--subtitle"
            v-html="Data.subTitle"
          />
        </div>
      </div>
      <div class="accordion-element__header__toggle-icons">
        <span v-if="!open">
          <font-awesome-icon
            v-if="!disabled"
            :icon="['fas', 'caret-down']"
          />
        </span>
        <span v-else>
          <font-awesome-icon
            v-if="!disabled"
            :icon="['fas', 'caret-up']"
          />
        </span>
      </div>
    </div>
    <div
      class="accordion-element__content"
      :class="{open}"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import $ from 'jquery'

export default {
  name: 'AccordionElement',
  components:
  {
    'font-awesome-icon': FontAwesomeIcon
  },
  props:
  {
    Data: {
      type: Object,
      default: function() {
        return{
          title: 'title',
          subTitle: 'subTitle'
        }
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return{
      open: false,
      status: null
    }
  },
  computed: {
    returnSubtitle() {
      if(this.Data && this.Data.subtitle) {
        return this.Data.subTitle
      }
      return null
    }
  },
  watch: {
    returnSubtitle() {
      this.setAccordion()
    },
    open(val) {
      if(val) {
        this.$nextTick(() => {
          const panel = this.$el.closest('.panel')

          if(panel) {
            const elY = this.$el.getBoundingClientRect().y
            const offset = elY - 45
            const scrollTop = panel.scrollTop + offset
  
            $(this.$el.closest('.panel')).animate({scrollTop}, 400)
          }
        })
      }
    }
  },
  mounted() {
    this.setAccordion()
    // Slot cannot receive normal events
    this.$on('setPageMessageParent', this.setPageMessage)
  },
  destroyed() {
    this.$off('setPageMessageParent', this.setPageMessage)
  },
  methods: {
    setPageMessage(message) {
      this.$emit('set-page-message', message)
    },
    setAccordion() {
      if(this.Data && this.Data.subtitle) {
        const severityList = ['red', 'yellow', 'blue', 'green']

        for (let i = 0; i < severityList.length; i++) {
          if(this.Data.subTitle.indexOf(`"${severityList[i]}"`) !== -1) {
            this.status = severityList[i]
            break
          }
        }
      } else {
        return null
      }
    },
    toggleState(e) {
      this.$set(this, 'open', !this.open)
    }
  }
}
</script>

<style lang="scss">
  .accordion-element {
    position: relative;

    $fontSize: 30px;

    .red {
      color: $color-red-error;
    }
    .green {
      color: $color-green-ok;
    }
    .yellow {
      color: darken(tint($color-yellow-warn, $color-red, 90), 7);
    }
    .blue {
      color: $color-blue-marine;
    }

    &__header {
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: (-$application-base-padding * 2) (-$application-base-padding * 2);
      padding: $application-base-padding * 2;
      cursor: pointer;
      box-shadow: 0 0 5px #333;
      transform: translateZ(0);
      z-index: 1;

      &__toggle-icons {
        font-size: $fontSize;
        padding-left: 10px;
      }

      &__text {
        display: grid;
        grid-template-columns: $fontSize 1fr;
        grid-gap: $fontSize / 1.5;
      }
    }

    &__icon {
      font-size: $fontSize * 1.1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    &__title {
      margin: 0;
      font-family: $font-primary-semibold;
      display: flex;
      font-size: $fontSize / 2;
      line-height: $fontSize / 2;

      &--subtitle {
        font-family: $font-primary;
        margin-top: 5px;
      }
    }
    &__content {
      box-sizing: border-box;
      height: 0;
      overflow: hidden;

      &.open {
        height: auto;
        > *:first-child {
          margin-top: 10px + $application-base-padding * 2;
        }
      }

    }
  }
</style>
